import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Grid, Form, TextArea, Button } from 'semantic-ui-react';
import { StyledNotesContainer } from 'components/Layout';

const wrapWithDivOrform = (prop, child) => prop.anagrafica ? // NOTE: Essendo presente il componente sia in pratica che in anagrafica, in anagrafica rimuovo il tag form causa dom validation (form dentro form)
                                            (<div>{child}</div>) :
                                            (<Form>{child}</Form>);

export const NewNote = (props) => {
  const submit = _.debounce(props.submit, 1000);
  return (
    <StyledNotesContainer>
      <Grid style={{ padding: 14 }}>
        <Grid.Column width={16} style={{ paddingBottom: 0 }}>
          {wrapWithDivOrform(props,
            <TextArea
              style={{ minHeight: 75 }}
              autoHeight
              placeholder="Inserisci la tua nota"
              value={props.nota}
              onChange={(e, data) => props.onChange(data.value)}
            />
          )}
        </Grid.Column>
        <Grid.Column width={16} textAlign="right">

          <Button.Group basic size="small" >
            <Button type="button" basic style={{ marginLeft: -1, marginTop: -1, marginBottom: -1 }} icon="remove" color={'red'} onClick={props.reset} />
            <Button type="button" basic style={{ marginright: -1, marginTop: -1, marginBottom: -1, marginLeft: -2 }} icon="checkmark" color="green" onClick={submit} />
          </Button.Group>
        </Grid.Column>
      </Grid>
    </StyledNotesContainer>
  );
};

NewNote.propTypes = {
  submit: PropTypes.func,
  reset: PropTypes.func,
  onChange: PropTypes.func,
  nota: PropTypes.string,
};

export default NewNote;



// WEBPACK FOOTER //
// ./app/components/Note/newNote.js